import script from "./AdminUser.vue?vue&type=script&setup=true&lang=ts"
export * from "./AdminUser.vue?vue&type=script&setup=true&lang=ts"

import "./AdminUser.vue?vue&type=style&index=0&id=770e410c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-770e410c"]])

export default __exports__